import css from 'styled-jsx/css';

const styles = css.global`#rastreadores-Modal {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

#rastreadores-Modal .modal-contain {
  width: 314px;
  left: 0px;
  top: 0px;
  background: #FFFFFF;
  border: 1px solid rgba(34, 34, 34, 0.4);
  border-radius: 5px;
}

#rastreadores-Modal .modal-contain .img-modal {
  display: flex;
  margin: 16px auto 0;
}

#titulo-modal {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  
  text-align: center;

  color: #000000;
  max-width: 187px;
  margin: 16px auto 0;
}

#mensagem-modal {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  /* or 171% */

  text-align: center;

  color: #222222;
  margin: 16px auto 0;
  padding: 0 16px;
}

#mensagem-modal a {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #222222;
  text-decoration: underline;
}

#botao-modal {
  font-family: 'SantanderText';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  text-decoration-line: underline;
  color: #CC0000;
  margin: 16px 0 16px;
}

@media (min-width: 992px) { 
  #rastreadores-Modal .modal-contain {
    width: 484px;
  }
  
  #rastreadores-Modal .modal-contain .img-modal {
    width: 48px;
    height: 48px;
    margin: 43px auto 0;
  }
  
  #titulo-modal {
    font-size: 24px;
    line-height: 36px;
    max-width: 100%;
    margin: 8px auto 0;
  }
  
  #mensagem-modal {
    font-size: 18px;
    line-height: 28px;
    margin: 18px auto 0;
    padding: 0 32px;
  }

  #mensagem-modal a {
    font-size: 18px;
    line-height: 28px;
  }
  
  #botao-modal {
    font-size: 20px;
    line-height: 28px;
    margin: 24px 0 32px;
    cursor: pointer;
  }
}`;

export default styles;